import menu from './menu';
import notifications from './notifications';

export default {
    rootPath: window.env.APP_URL,
    cmsPath: '/admin',
    cmsTitle: window.env.APP_NAME,
    routes: {
        default: '/dashboard',
        endpoints: {
            '^/pages': {
                params: { filter: 'parent_id:$null' },
            },
            '^/panels': {
                params: { filter: 'content_id:$null' },
            },
            '^/enquiries': {
                params: { sort: 'created_at:desc' }
            },
            '^/customers': {
                params: { filter: 'id(ca):$customer_active(active);', sort: 'name:asc', with: 'logins,delivery_addresses' }
            },
            '^/customer_logins': {
                params: { append: 'customer_list', sort: 'firstname:asc', }
            },
            '^/customer_login/[0-9]+/login_log': {
                params: { sort: 'created_at:desc' }
            },
            '^/nav_categories': {
                params: { sort: 'name:asc' }
            },
            '^/orders': {
                params: { sort: 'order_date:desc' }
            },
            '^/order/[\\d]+$': {
                params: { include: 'items' }
            },
            '^/freights': {
                params: { per_page: 99999999 }
            },
            '^/products': {
                params: { filter: 'id(av):$available;' }
            },
            '^/promotion/[0-9]+/products_applicable': {
                params: { per_page: 99999999 }
            },
            '^/promotion/[0-9]+/products_free': {
                params: { per_page: 99999999 }
            },
        }
    },
    file: {
        extensions: {
            img: ['png', 'jpg', 'jpeg', 'gif', 'svg'],
            doc: ['doc', 'docx'],
            pdf: ['pdf'],
            xls: ['xls', 'xlsx'],
            mp4: ['mp4', 'webm'],
            csv: ['csv'],
            mod: ['mod'],
            dwg: ['dwx', 'dwg'],
        }
    },
    menu,
    notifications,
    inboxActive: false,
}
